export class UsuariosCargosNomesModel {
  id: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos-nomes/usuarios-cargos-nomes.model.ts